'use client';

import Link from 'next/link';
import SVGIcon from '@/components/SVGIcon';
import { useAuthStore } from '@/lib/store';

export default function NotFound() {
  const { isAuthenticated } = useAuthStore();
  return (
    <div className="flex flex-col items-center justify-center p-8 gap-6 min-h-[400px]">
      <div className="flex flex-col items-center justify-center p-8 gap-6 w-full max-w-3xl">
        {/* 404 Icon */}
        <div className="flex items-center justify-center">
          <SVGIcon
            src="/images/page-not-found.svg"
            width={70}
            height={70}
            iconColor="var(--color-mono-400, #9694b2)"
          />
        </div>

        <div className="flex flex-col items-center gap-2">
          <h3 className="xl-text font-medium text-action-900 text-center">
            An exact match for this URL could not be found.
          </h3>

          <p className="body-base text-mono-700 text-center">
            The page you’re looking for doesn’t exist or may have moved. Let’s get you back on
            track.
          </p>
        </div>

        <div className="flex gap-4">
          {isAuthenticated ? (
            <Link href="/dashboard" className="btn-primary">
              Go to Dashboard
            </Link>
          ) : (
            <Link href="/login" className="btn-primary">
              Login
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
